import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { COLORS } from '../styles/colors';
import LoadMoreIcon from './LoadMoreIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import Search from './workouts/search';
import WorkoutPreviewButton from './WorkoutPreviewButton';
import ProgramPreviewButton from './ProgramPreviewButton';
import AutomationPreviewButton from './AutomationPreviewButton';
import { ConfirmJsMessage } from './../helpers.js'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const TAB_LABELS = ['My Created', 'Fitbanx', 'My Assigned'];

const grid = 2;

const getItemStyle = (isDragging, draggableStyle) => ({
	// some basic styles to make the items look a bit nicer
	userSelect: "none",
	paddingLeft: `5px`,

	paddingTop: `15px`,
	
	margin: `0 0 ${grid}px 0`,

	
	// change background colour if dragging
	background: isDragging ? "lightgray" : "white",
  
	// styles we need to apply on draggables
	...draggableStyle
  });
  
const getListStyle = isDraggingOver => ({
	background: isDraggingOver ? "lightblue" : "#f2f3f4",
	padding: grid
});

const sortByAdded = (a, b) => {
	if (a.added > b.added) {
		return -1;
	}
	if (a.added < b.added) {
		return 1;
	}
	return 0;
};

const textTruncate = function(str, length, ending) {
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str && str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };

class SelectionList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			tab: props.defaultTab ? props.defaultTab : 0,
			categoryId: '0',
			search: '',
			orderWorkouts: []
		};
	}

	static getDerivedStateFromProps(nextProps, prevState){
		if(nextProps.itemType !== prevState.itemType){
		  return { itemType: nextProps.itemType};
	   }
	   else return null;
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.itemType!== this.props.itemType){
			if (this.state.tab !== 2) {
				this.handleFilter();
			}
		}
	}

	componentDidMount() {
		if (this.state.tab !== 2) {
			this.handleFilter();
		}
		if (this.state.tab === 2) {
		}
	}

	reorder = (list, startIndex, endIndex) => {
		const result = Array.from(list);
		const movedItem = result.find((item, index) => index === startIndex);
		const remainingItems = result.filter((item, index) => index !== startIndex);
		const reorderedItems = [
		  ...remainingItems.slice(0, endIndex),
		  movedItem,
		  ...remainingItems.slice(endIndex)
		];
		return reorderedItems;
	};

	onDragEnd = (result) =>  {
		if (!result.destination) {
		  return;
		}
		const items = this.reorder(
			Object.values(this.props.selectedItems),
			result.source.index,
			result.destination.index
		);
		const obj = {};
		for(let i = 0; i < items.length; i++) {
			const item = items[i];
			obj[item._id] = item;
		}
		const { onSelectedItem, updateSelectedItems } = this.props;
		if (updateSelectedItems) {
			updateSelectedItems(obj);
		}
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};

	handleFilter(skip=0) {
		const { tab, categoryId, search } = this.state;
		if (tab !== 2) {
			let query = {}
			const { user, itemType } = this.props;
			switch (tab) {
				case 0:
					query.creatorId = user._id;
					break;
				case 1:
					query.creatorType = 'corporate';
					if(itemType !== 'automation') {
						query.isArchive = false;
					}
					break;
			}
			query.categoryId = categoryId !== '0' ? categoryId : undefined
			query.search = search !== '' ? search : undefined;
			query.skip = skip;
			query.limit = 10;
			if(skip === 0) {
	  		  this.props.resetListing();
			}
			query.itemType = itemType;
			this.props.fetchMore(query);
		}
	}

	toggleSelectedItem(item) {
		let newItems = this.props.selectedItems;
		const { maxSelected, onSelectedItem, updateSelectedItems } = this.props;

		if (newItems[item._id]) {
			delete newItems[item._id];
		} else {
			item.added = new Date().getTime();
			newItems[item._id] = item;
		}
		const size = Object.keys(newItems).length;
		if (maxSelected > 0 && size > maxSelected) {
			const oldest = Object.values(newItems).sort(sortByAdded).pop();
			let confirm = true;
			if (maxSelected > 1) {
				confirm = window.confirm(
					`Only 12 workouts are allowed in the My Assigned section.  Please uncheck the workout you want to replace in the My Assigned section before selecting a new workout to assign to your Coach Channel.`
				);
			}
			if (confirm) {
				delete newItems[oldest._id];
			} else {
				delete newItems[item._id];
				return;
			}
		}

		if (updateSelectedItems) {
			updateSelectedItems(newItems);
		}
		if (onSelectedItem) {
			onSelectedItem(item);
		}
	}


	renderCategorySelect() {
		const { categories } = this.props;
		if (categories) {
			return (
				<TextField
					select
					label="Category"
					value={this.state.categoryId}
					onChange={e =>
						this.setState({ ...this.state, categoryId: e.target.value }, () => {
							this.handleFilter();
						})
					}
					margin="dense"
					variant="outlined"
				>
					<MenuItem key="no-cat" value="0">
						All
					</MenuItem>
					{Object.values(categories).map(option => (
						<MenuItem key={option._id} value={option._id}>
							{option.name}
						</MenuItem>
					))}
				</TextField>
			);
		}
		return null;
	}
	render() {
		const { search, categoryId, tab } = this.state;
		const {
			categoryField,
			creatorTabs,
			user,
			selectedItems,
			maxSelected,
			itemType,
			maxListHeight,
			hideFilters,
			isLoadMore,
			isFeatureBrand,
			isRemoveWidth,
			isEditDay
		} = this.props;
		let {
			items,
		} = this.props;
		
		const hideTabs = this.props.hideTabs ? this.props.hideTabs : [];
		const tabAlias = this.props.tabAlias ? this.props.tabAlias : [];
		const hideItemToggle = this.props.hideItemToggle
			? this.props.hideItemToggle
			: false;
		const tabStyle = {
			width: 125,
			backgroundColor: COLORS.greyFour,
		};

		if (tab === 2) {
			items = Object.values(selectedItems);
			items = items.filter(item => {
				
				let catQuery = true;
				if (categoryId) {
					if (item[categoryField] && categoryId !== '0') {
						catQuery = item[categoryField] === categoryId;
					}
				}
	
				let searchQuery = true;
				if (search) {
					const lookup = item.name;
					searchQuery = lookup.toUpperCase().includes(search.toUpperCase());
				}
				return searchQuery && catQuery;
			});
			items = items.sort(sortByAdded);
		}

		return (
			<div>
				<div>
					{creatorTabs ? (
						<Tabs
							TabIndicatorProps={{
								style: {
									background: COLORS.orange,
									height: 5,
								},
							}}
							style={{ justifyContent: 'center' }}
							value={this.state.tab}
							onChange={(e, value) => {
								const _that = this;
								this.setState({ ...this.state, tab: value }, () => {
									this.handleFilter();
								});
							}}
						>
							{TAB_LABELS.map((label, index) => (
								<Tab
									key={index}
									style={
										!hideTabs.includes(index) ? tabStyle : { display: 'none' }
									}
									label={tabAlias[index] ? tabAlias[index] : label}
								/>
							))}
						</Tabs>
					) : null}
				</div>
				<div
					style={{
						borderTop: '1px solid ' + COLORS.grey,
						backgroundColor: COLORS.greyFour,
						paddingTop: 25,
						paddingBottom: 25,
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
					{hideFilters ? null : (
						<div
							style={{
								width: isRemoveWidth ? undefined : 400,
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<div style={{ 
								width: '45%', 
								marginRight: '5%',
								marginLeft:  itemType === 'automation' && '30%'
							}}>
								
								<Search changeSearch={(term) => {
									this.setState({
										search: term
									}, () => {
										this.handleFilter();
									})
								}}></Search>
                      		</div>
							{ itemType !== 'automation' &&
								<div style={{ width: '50%' }}>{this.renderCategorySelect()}</div>
							}	
						</div>
					)}

					{maxSelected && tab === 2 ? (
						<div>
							{
								// Sorted by Lastest Added
							}
						</div>
					) : null}
					<div style={{ width: '100%' }} >
						<div
							style={{
								overflow: 'auto',
								height: this.props.isClientForm ? 300 : 200
							}}
							id = "scrollableDiv"
						>

						{ tab === 2 && !isFeatureBrand &&
							<DragDropContext  onDragEnd={this.onDragEnd}>
							 <Droppable droppableId="droppable">
							   {(provided, snapshot) => (
								 <div
								   ref={provided.innerRef}
								   style={getListStyle(snapshot.isDraggingOver)}
								 >
								   {items.map((item, index) => (
									 <Draggable key={item._id} draggableId={item._id} index={index}>
									   {(provided, snapshot) => (
										 <div
										   ref={provided.innerRef}
										   {...provided.draggableProps}
										   {...provided.dragHandleProps}
										   style={getItemStyle(
											 snapshot.isDragging,
											 provided.draggableProps.style
										   )}
										   className={
											selectedItems[item._id] && this.props.addSelectedClass
												? 'listItem selected'
												: 'listItem'
											}
											key={index}
										 >
										
										
											<div
												style={{
													width: '95%',
													display: 'flex',
													alignItems: 'center',
												}}
											>
												{hideItemToggle ? null : (
													<FormControlLabel
														style={{ marginRight: 0 }}
														control={
															<Checkbox
																checked={Boolean(selectedItems[item._id])}
																onChange={e => {
																	if (
																		selectedItems[item._id] &&
																		this.props.unselectWarningMessage
																	) {
																		if (
																			ConfirmJsMessage(
																				this.props.unselectWarningMessage
																			)
																		) {
																			this.toggleSelectedItem(item);
																		}
																	} else {
																		this.toggleSelectedItem(item);
																	}
																}}
																value=""
															/>
														}
													/>
												)}

												<div>
													<b>{item.name}</b>
													<br />
													{ textTruncate(item.description, 40, '...') }
												</div>
											</div>
											<div style={{ width: '5%' }}>
												{!itemType || itemType === 'workout' ? (
													<WorkoutPreviewButton workout={item} />
												) : null}
											</div>
										</div>
										   
									   )}
									 </Draggable>
								   ))}
								   {provided.placeholder}
								 </div>
							   )}
						 </Droppable>
					   </DragDropContext>
						}

						{ tab === 2 && isFeatureBrand &&
							items.map((item, index) => (
										<div
										className={
										selectedItems[item._id] && this.props.addSelectedClass
											? 'listItem selected'
											: 'listItem'
										}
										key={index}
										>
									
									
										<div
											style={{
												width: '95%',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											{hideItemToggle ? null : (
												<FormControlLabel
													style={{ marginRight: 0 }}
													control={
														<Checkbox
															checked={Boolean(selectedItems[item._id])}
															onChange={e => {
																if (
																	selectedItems[item._id] &&
																	this.props.unselectWarningMessage
																) {
																	if (
																		ConfirmJsMessage(
																			this.props.unselectWarningMessage
																		)
																	) {
																		this.toggleSelectedItem(item);
																	}
																} else {
																	this.toggleSelectedItem(item);
																}
															}}
															value=""
														/>
													}
												/>
											)}

											<div>
												<b>{item.name}</b>
												<br />
												{ textTruncate(item.description, 40, '...') }
											</div>
										</div>
										<div style={{ width: '5%' }}>
											{!itemType && itemType === 'workout'? (
												<WorkoutPreviewButton workout={item} />
											) : null}
										</div>
									</div>
							))
						}

						{ tab !== 2 &&
							<InfiniteScroll
								dataLength={items.length} //This is important field to render the next data
								next={() => this.handleFilter(items.length)}
								hasMore={isLoadMore}
								scrollableTarget="scrollableDiv"
								loader={<LoadMoreIcon/>}
							>
								{items.map((item, index) => (
									<div
										className={
											selectedItems[item._id] && this.props.addSelectedClass
												? 'listItem selected'
												: 'listItem'
										}
										key={index}
									>
										<div
											style={{
												width: '95%',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											{hideItemToggle ? null : (
												<FormControlLabel
													style={{ marginRight: 0 }}
													control={
														<Checkbox
															checked={Boolean(selectedItems[item._id])}
															onChange={e => {
																if (
																	selectedItems[item._id] &&
																	this.props.unselectWarningMessage
																) {
																	if (
																		ConfirmJsMessage(
																			this.props.unselectWarningMessage
																		)
																	) {
																		this.toggleSelectedItem(item);
																	}
																} else {
																	this.toggleSelectedItem(item);
																}
															}}
															value=""
														/>
													}
												/>
											)}

											<div>
												<b>{item.name}</b>
												<br />
												{ textTruncate(item.description, 40, '...') }
											</div>
										</div>
										<div style={{ width: '10%' }}>
											{!itemType || itemType === 'workout' ? (
												<WorkoutPreviewButton workout={item} />
											) : null}
											{ itemType === 'program' ? (
												<ProgramPreviewButton program={item} />
											) : null}
										
											{ itemType === 'automation' ? (
												<AutomationPreviewButton automation={item} />
											) : null}
										</div>
									</div>
								))}
							</InfiniteScroll>
						}
						</div>
					</div>
					<div>
						{maxSelected ? (
							<span>
								{Object.keys(selectedItems).length} of {maxSelected} selected.
							</span>
						) : null}
						{
							// <span style={{float:'right'}}>
							//   { filteredItems.length } items.
							// </span>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default SelectionList;



// WEBPACK FOOTER //
// ./src/components/SelectionList.js